<template>

  <div>

    <!--<pre>{{data}}</pre>-->

    <v-container grid-list-xl class="mt-2">

      <h2>All Available Sensor Variables</h2>

      <h3>This is a method for reviewing ALL the sensor variables available through the MesoWest API.</h3>

      <p>Click a variable to see which of the "favorite" sensors have data for that variable.  Filter using the search input.</p>

      <v-text-field style="max-width: 300px;" label="Search all variables" v-model="filter"
                    @keyup="saveFilter"></v-text-field>

      <v-layout row wrap>

        <v-flex xs6 lg4 fill-height v-for="d, index in filteredData" :key="index">

          <v-card color="grey darken-1" class="white--text" :to="`/variable/${d.name}`">
            <v-card-title>
              <h4 class="ma-0 pa-0">{{d.long_name}}</h4>
            </v-card-title>
            <v-card-text class="light-blue white--text">
              <div>Abbrev: {{d.name}}</div>
              <div>Unit: {{d.unit}}</div>
              <div>VID: {{d.vid}}</div>
            </v-card-text>
          </v-card>

        </v-flex>

      </v-layout>

    </v-container>

  </div>

</template>

<script>
  import getStationVariables from '@/api/get-station-variables';

  export default {

    name: 'VariableList',

    data() {
      return {
        filter: this.$store.state.universal.filters.variable,
      };
    },

    async mounted() {
      const variables = await getStationVariables();
      console.log(variables);
      this.$store.commit('setAllVariables', variables);
    },

    methods: {
      saveFilter(e) {
        this.$store.commit('setFilterVariable', e.target.value);
      },
    },

    computed: {

      filteredData() {
        return this.$store.state.universal.allVariables.filter(val => val.long_name.toLowerCase().includes(this.filter.toLowerCase()));
      },

    },

  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/VariableList.vue